import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';

export interface IDynamicDefaultValueMixin {
  defaultValue: string | string[] | undefined;
}
export type DynamicDefaultValueCtor = Constructor<IDynamicDefaultValueMixin>;

export function mixinDynamicDefaultValue<T extends Constructor<{}>>(base: T): DynamicDefaultValueCtor & T {
  class DynamicDefaultValueMixin extends base implements IDynamicDefaultValueMixin {
    @DynamicProperty() defaultValue: string | string[] | undefined;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicDefaultValueMixin;
}
